import React from "react";

const Templatelist = React.memo(
  function Templatelist({ template, selectedTemplate, handleTemplateSelectionFunction }) {
    const isSelected = selectedTemplate?.id === template.id;

    return (
      <div className="col-12 col-md-6 col-lg-4 mb-3">
        <div
          className={`card cursor-pointer h-100 transition-all ${
            isSelected ? "border-success shadow-sm" : "border-light"
          }`}
          style={{
            borderRadius: "12px",
            borderWidth: isSelected ? "2px" : "1px",
            borderColor: isSelected ? "#075E54" : "#e2e8f0",
            transition: "all 0.2s ease"
          }}
          onClick={() => {
            if (!isSelected && typeof handleTemplateSelectionFunction === 'function') {
              handleTemplateSelectionFunction(template);
            }
          }}
        >
          <div
            className="card-body rounded p-3 d-flex flex-column justify-content-between"
            style={{
              cursor: "pointer",
              backgroundColor: isSelected ? "#f0fdf4" : "#ffffff",
              borderRadius: "10px"
            }}
          >
            <div>
              <div className="d-flex justify-content-between align-items-start mb-2">
                <h6 className="card-title fw-bold text-dark mb-0 text-truncate" title={template.name || template.template_name}>
                  {template.name || template.template_name || "Unnamed Template"}
                </h6>
                <span className={`badge ${template.status === 'APPROVED' ? 'bg-success' : 'bg-warning text-dark'}`}>
                  {template.status || "UNKNOWN"}
                </span>
              </div>

              <p className="card-text small text-muted mb-2 text-capitalize">
                Category: {template.category || "General"}
              </p>
            </div>

            {template.variables && template.variables.length > 0 && (
              <div className="mt-2 pt-2 border-top">
                <small className="text-primary fw-medium">
                  ⚡ {template.variables.length} variable(s) mapped
                </small>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  },
  (prevProps, nextProps) => {
    const wasSelected = prevProps.selectedTemplate?.id === prevProps.template.id;
    const isSelected = nextProps.selectedTemplate?.id === nextProps.template.id;
    return (
      wasSelected === isSelected &&
      prevProps.template?.id === nextProps.template?.id &&
      prevProps.handleTemplateSelectionFunction === nextProps.handleTemplateSelectionFunction
    );
  }
);

export default Templatelist;